$ = require 'jquery'
{ getKey, Key } = require '@trello/keybindings'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
_ = require 'underscore'
SearchInputTemplate = require 'app/scripts/views/templates/board_sidebar_search_input'
l = require 'app/scripts/lib/localize'

module.exports = class SearchInputView extends View
  className: 'board-menu-content-frame'

  initialize: ->
    @listenTo @model, 'change', @renderInputIcon

  events:
    'keyup .js-input': 'keyUpEvent'
    'keydown .js-input': 'keyDownEvent'
    'click .js-search-clear-title': 'clearAndFocusInput'
    'click .js-search-open-card-filter': 'showCardFilter'

  render: ->
    @$el.html(SearchInputTemplate.renderInputRow({
      title: @model.get('title')
      showFilterButton: @options?.showCardFilter?
    }))

    @renderInputIcon()

    @

  renderInputIcon: ->
    @$('.js-input-search-icon').html(SearchInputTemplate.renderInputIcon({
      title: @model.get('title')
    }))

  keyUpEvent: (e) ->
    # esc will remove the input value and subsequently the search
    # title from filter array if selected, so just return if esc
    # is hit (will close the popover like normal)
    key = getKey(e)
    return if key in [Key.Escape, Key.Enter, Key.ArrowUp, Key.ArrowDown]

    @model.save({
      title: @$('.js-input').val()
      limitMembers: true
      limitLabels: true
    })

  keyDownEvent: (e) ->
    key = getKey(e)
    if key == Key.Enter
      @showCardFilter()

  clearAndFocusInput: ->
    @model.save({ title: "" })
    @$('.js-input').val("").focus()

  showCardFilter: ->
    @options?.showCardFilter?()
